import { isLightColor } from "../../../shared/helpers";
import Chart from "chart.js";

export const statusMap = {
    active: {
        label: "Active",
        color: "#000",
    },
    completed: {
        label: "Completed",
        color: "#000",
    },
    todo: {
        label: "Open",
        color: "#68b7dc",
    },
    "to-do": {
        label: "Open",
        color: "#68b7dc",
    },
    ready: {
        label: "Ready",
        color: "#6872dc",
    },
    redo: {
        label: "Redo",
        color: "#a368dc",
    },
    "copy-complete": {
        label: "Copy is complete",
        color: "#d9d9d9",
    },
    copying: {
        label: "Copy in progress",
        color: "#bfbfbf",
    },
    editing: {
        label: "Editing in progress",
        color: "#a6a6a6",
    },
    uploading: {
        label: "Upload in progress",
        color: "#7f7f7f",
    },
    "in-progress": {
        label: "In Progress",
        color: "#bfbfbf",
    },
    "waiting-for-ca": {
        label: "Awaiting Client Approval",
        color: "#a6a6a6",
    },
    error: {
        label: "Error",
        color: "#ff9896",
    },
    "dq-failed": {
        label: "DQ Failed",
        color: "#ff9896",
    },
};

export const chartTasks = ["to-do", "ready", "redo", "copy-complete", "copying", "uploading", "editing", "waiting-for-ca", "error", "dq-failed"];

export const countTasks = [
    "active",
    "to-do",
    "ready",
    "redo",
    "copy-complete",
    "copying",
    "uploading",
    "editing",
    "in-progress",
    "waiting-for-ca",
    "error",
    "dq-failed",
];

export const assignmentBarOptions = {
    tooltips: {
        mode: "index",
        axis: "y",
        intersect: false,
        includeInvisible: true,

        custom: function (tooltipModel) {
            // Tooltip Element
            let tooltipEl = document.getElementById("chartjs-tooltip");

            // Create element on first render
            if (!tooltipEl) {
                tooltipEl = document.createElement("div");
                tooltipEl.id = "chartjs-tooltip";
                tooltipEl.innerHTML = "<table></table>";
                document.body.appendChild(tooltipEl);
            }

            // Hide if no tooltip
            if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = 0;

                return;
            }

            // Set caret Position
            tooltipEl.classList.remove("above", "below", "no-transform");

            if (tooltipModel.yAlign) {
                tooltipEl.classList.add(tooltipModel.yAlign);
            } else {
                tooltipEl.classList.add("above", "no-transform");
            }

            const getBody = (bodyItem) => {
                return bodyItem.lines;
            };

            // Set Text
            if (tooltipModel.body) {
                const titleLines = tooltipModel.title || [];
                const bodyLines = tooltipModel.body.map(getBody);
                let innerHtml = "<thead>";

                titleLines.forEach(function (title) {
                    innerHtml += "<tr><th>" + title + "</th></tr>";
                });
                innerHtml += "</thead><tbody>";

                // Color square next to labels
                bodyLines.forEach(function (body, i) {
                    const colors = tooltipModel.labelColors[i];
                    let style = "background-color:" + colors.backgroundColor;
                    style += "; border-color:" + colors.borderColor;
                    style += "; border-width: 2px";
                    style += "; height: 10px";
                    style += "; width: 10px";
                    style += "; display: inline-block";
                    style += "; margin-right: 5px";

                    const span = '<span style="' + style + '"></span>';
                    innerHtml += "<tr><td>" + span + body + "</td></tr>";
                });
                innerHtml += "</tbody>";

                let tableRoot = tooltipEl.querySelector("table");
                tableRoot.innerHTML = innerHtml;
            }

            // Display, position, and set styles for font
            tooltipEl.style.opacity = 1;
            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
            tooltipEl.style.padding = tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
            tooltipEl.style.backgroundColor = tooltipModel.backgroundColor;
            tooltipEl.style.color = tooltipModel.bodyFontColor;
        },
    },
    hover: {
        animationDuration: 0,
    },
    scales: {
        xAxes: [{ stacked: true }],
        yAxes: [{ stacked: true }],
    },
    animation: {
        duration: 500,
        easing: "easeOutQuart",
    },
};

export const convertToChartDatasets = (data) => {
    return Object.keys(data)
        .sort((a, b) => chartTasks.indexOf(a) - chartTasks.indexOf(b))
        .reduce((arr, key) => {
            if (chartTasks.includes(key)) {
                arr.push({
                    label: statusMap[key].label,
                    data: data[key],
                    backgroundColor: statusMap[key].color,
                });
            }

            return arr;
        }, []);
};
